<template>
  <div class="game-box">
    <div v-for="item in gameList" :key="item.textKey" class="game-item" :title="item.title" @click="onEnterGames(item)">
      <div v-if="item.showTag" class="tag">{{ $t('home.text3') }}</div>
      <div v-if="!item.canPlay" class="tag">{{ $t('home.text4') }}</div>
      <img :src="item.imgPath" :alt="item.title">
      <div class="d-text">
        <!-- <div class="name">{{ item.name }}</div> 依照 dicke 拿掉數字顯示 -->
        <div v-if="item.canPlay" class="btn-main">
          <span>{{ $t('banner.text6') }}</span>
          <div>{{ $t('banner.text6') }}</div>
        </div>
        <div v-else class="btn-main coming-soon">
          {{ $t('home.text4') }}
        </div>
      </div>
    </div>
    <dialog-custom :dialog-visible="dialogVisible" @close="dialogVisible = false" @onLogin="onLogin" />

  </div>
</template>

<script>
// import store from "@/store";
// import { gameList } from '@/axios/userInfo';
import {GameList} from '@/assets/docs/gameCategory'
import DialogCustom from "@/components/Dialog";
export default {
  name: 'GameBox',
  components: { DialogCustom },
  data() {
    return {
      dialogVisible:false,
      enterGameData:''
    }
  },
  computed:{
    gameList(){
      let gameListArr = GameList
      let lang = localStorage.getItem('lang')
      gameListArr.map((item,index) => {
        item.showTag = (item.key == 'Fire Ball Day of the Dead')
        item.canPlay = index < 3
        item.name = this.$t(item.textKey)
        item.title = this.$t(item.altKey)
        item.imgPath = item.hasOwnProperty(`img-${lang}`) ? item[`img-${lang}`] : item.img
      })
      return gameListArr
    }
  },
  created() {
  },
  methods: {
    onLogin(){
      let langMap= {
        'en':'en',
        'th':'th_TH',
        'zh':'zh_CN'
      }
      let langText = localStorage.getItem('lang') || 'en'
      let Language = langMap[langText]

      let ClientIp = "demo.pgf-aspd7a.com";
      let platformId = 27
      // if(Language == 'th_TH') {
      //   platformId = 26
      //   ClientIp = "s1-gaming.com"
      // }
      let Token = this.$store.state.gameToken
      let FolderName = this.enterGameData.FolderName
      if(!FolderName) return;
      //test
      var GameUrl = 'https://' + ClientIp + '/Game/' + FolderName + '/?token=' + Token + '&platformId=' + platformId + '&lang=' + Language ;
      // console.log("準備連到GS => GameUrl=" + GameUrl);
      // // 轉網頁
      this.enterGameData = ''
      this.dialogVisible = false
      //另開分頁
      // window.open(GameUrl, '_blank');
      setTimeout(() => {
        window.open(GameUrl, '_blank');
      })
    },
    onEnterGames(item){
      if(!item.canPlay) return
      if(window.gtag) {
        window.gtag('event', 'click_play_now', {
        'event_category': 'button',
        'event_label': '立即試玩'
      });
      }
      
      this.dialogVisible = true
      this.enterGameData = item
      // let time = 24 * 60 * 60 * 1000  // 24小時
      // let lastLoginTime = localStorage.getItem('lastLoginTime')
      // let now = +new Date()
      // const isMoreThan24Hours = Math.abs(now - lastLoginTime) > time;
      // if(!this.$store.state.gameToken || isMoreThan24Hours){
      //   this.dialogVisible = true
      //   store.commit('SET_GAME_TOKEN', '')
      //   localStorage.removeItem('lastLoginTime')
      //   localStorage.removeItem('gameToken')
      //   return
      // }
      // let langMap= {
      //   'en':'en',
      //   'th':'th_TH',
      //   'zh':'zh_CN'
      // }
      // let langText = localStorage.getItem('lang') || 'en'
      // let Language = langMap[langText]
      // var ClientIp = "demo-slot.jiauwhdagyi.com";
      // let Token = this.$store.state.gameToken
      // let FolderName = item.FolderName
      // if(!FolderName) return;
      // //test
      // var GameUrl = 'https://' + ClientIp + '/Game/' + FolderName + '/?token=' + Token + '&platformId=' + 2 + '&lang=' + Language ;
      // // console.log("準備連到GS => GameUrl=" + GameUrl);
      // // // 轉網頁
      // window.open(GameUrl, '_blank');//另開分頁

    }
    // async getList() {
    //   try {
    //     const params = {
    //       clientId: 'JksxUbWNDwyvLY0',
    //       clientKey: 'DDd5gEJKa4Vg9rhEsy509zYL'
    //     }
    //     await gameList(params)
    //   } catch (err) {
    //     console.log('err:: ', err);
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>@use "@/assets/scss/GameBox.scss";</style>
